
/* eslint no-unused-expressions: "off" */

import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { ChartLine } from '@/components/Chart';
import api from '@/api';
import moment from 'moment';
import 'chart.js';

@Component({
  components: {
    ChartLine,
  },
})
export default class Dashboard extends Vue {
  private userData: Chart.ChartData = { datasets: [] };

  private pointData: Chart.ChartData = { datasets: [] };

  private option = {
    responsive: true,
    maintainAspectRatio: false,
  };

  private label: { [key: string]: {name: string, color: string, }} = {
    Member_Total: { name: '有效總會員數', color: 'rgba(0,216,255,.8)' },
    Member_Real: { name: '實名驗證會員數', color: 'rgba(65,184,131,.8)' },
    Member_Basic: { name: '基本驗證會員數', color: 'rgba(228,102,81,.8)' },
    SwapIn_Total: { name: '換入總點數', color: 'rgba(0,216,255,.8)' },
    SwapIn_FriendInvite: { name: '好友邀請贈點', color: 'rgba(65,184,131,.8)' },
    SwapIn_VoucherRedeem: { name: '序號加點兌換', color: 'rgba(228,102,81,.8)' },
  };

  private async requestData() {
    const days = 30;
    const { data } = await (api as any).dashboard.list(days);
    const date = new Date();
    const labels = [...new Array<string>(days)]
      .map((val, idx) => {
        const d = new Date(date);
        d.setDate(d.getDate() - idx - 1);
        return moment(d).format('YYYY-MM-DD');
      })
      .sort();
    const userData: Chart.ChartData = { labels, datasets: [] };
    const pointData: Chart.ChartData = { labels, datasets: [] };

    data.forEach((item: any) => {
      const dataset: Chart.ChartDataSets = {
        label: this.label[item.type].name,
        backgroundColor: this.label[item.type].color,
        data: labels.map((val) => item.data[val]),
      };
      if (item.type?.startsWith('SwapIn')) {
        pointData.datasets?.push(dataset);
      } else {
        userData.datasets?.push(dataset);
      }
    });
    this.userData = userData;
    this.pointData = pointData;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (to?: (vm: Dashboard) => void) => void) {
    next(async (vm) => {
      await vm.requestData();
    });
  }
}
